
import { Component, Vue } from 'vue-property-decorator';
import SupportedBadge from '@/types/SupportedBadge';
import EcoFriendlyComponent from '@/components/SearchResults/Badges/EcoFriendlyComponent.vue';
import OvernightAvailableComponent from '@/components/SearchResults/Badges/OvernightAvailableComponent.vue';
import LogoFscComponent from '@/components/SearchResults/Badges/LogoFscComponent.vue';
import OnlineDesignComponent from '@/components/SearchResults/Badges/OnlineDesignComponent.vue';
import LogoPfscComponent from '@/components/SearchResults/Badges/LogoPfscComponent.vue';
import LogoFscPfscComponent from '@/components/SearchResults/Badges/LogoFscPfscComponent.vue';
import RatingComponent from '@/components/SearchResults/RatingComponent.vue';
import StopperComponent from '@/components/SearchResults/StopperComponent.vue';
import PriceComponent from '@/components/SearchResults/PriceComponent.vue';
import BrandComponent from '@/components/SearchResults/BrandComponent.vue';

@Component({
  name: 'search-result-base-component',
  components: {
    'badge-ecofriendly-component': EcoFriendlyComponent,
    'badge-logofsc-component': LogoFscComponent,
    'badge-logopfsc-component': LogoPfscComponent,
    'badge-logofscpfsc-component': LogoFscPfscComponent,
    'badge-overnightavailable-component': OvernightAvailableComponent,
    'badge-onlinedesign-component': OnlineDesignComponent,
    'rating-component': RatingComponent,
    'stopper-component': StopperComponent,
    'price-component': PriceComponent,
    'brand-component': BrandComponent,
  },
})
export default class SearchResultsBaseComponent extends Vue {
  /* eslint-disable-next-line */
  public componentName(badge: SupportedBadge): string {
    return `badge-${badge.toLowerCase()}-component`;
  }

  /* eslint-disable-next-line */
  public prepareBadges(badges: Array<SupportedBadge>): Array<SupportedBadge> {
    return badges.filter(
      (badge: SupportedBadge) => Object.values(SupportedBadge).includes(badge),
    );
  }
}
